class PlacementController {
    setPosition(object, x, y, z) {
        throw new Error("Method .setPosition is not implemented");
    }

    setEulerRotation(object, x, y, z, order) {
        throw new Error("Method .setEulerRotation is not implemented");
    }

    setQuaternionRotation(object, x, y, z, w) {
        throw new Error("Method .setQuaternionRotation is not implemented");
    }

    setScale(object, x, y, z) {
        throw new Error("Method .setScale is not implemented");
    }
}

export default PlacementController;
